module.exports = __webpack_public_path__ + "media/images/ln/horoscope_7-576ee7d380d480b8359f670dcce1ac38.png";